import WhatsAppLink from './WhatsAppLink'
import artcustomLogo from '../images/artcustom-logo.jpeg'
import artcustomAws from '../images/artcustom-aws.jpeg'
import artcustomPackage from '../images/artcustom-package.jpeg'

const HERO_IMAGES = [
  artcustomLogo,
  'https://images.unsplash.com/photo-1562157873-818bc0726f68?w=600&h=400&fit=crop',
  artcustomAws,
  artcustomPackage,
  'https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?w=600&h=400&fit=crop',
]

const Hero = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId)
    if (element) {
      const offsetTop = element.offsetTop - 80
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      })
    }
  }

  const duplicatedImages = [...HERO_IMAGES, ...HERO_IMAGES]

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20"
    >
      {/* Sliding Background Images */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="animate-slide-bg flex items-center gap-4 absolute inset-y-0 w-max py-4">
          {duplicatedImages.map((src, i) => (
            <img
              key={i}
              src={src}
              alt=""
              loading="lazy"
              className="h-full w-[400px] md:w-[500px] lg:w-[600px] object-cover rounded-2xl flex-shrink-0 opacity-90"
            />
          ))}
        </div>
      </div>

      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6">
            <span className="bg-gradient-to-r from-[#4da8e8] via-white to-[#f3eb03] bg-clip-text text-transparent drop-shadow-lg">
              Mais do que camisetas, uma solução de identidade para sua empresa
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed">
            Uniformes, eventos, ações promocionais, dentre outros com alto padrão
            para empresas e marcas que sabem o peso da primeira impressão.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <WhatsAppLink className="bg-gradient-to-r from-[#0877c5] to-[#b51625] text-white px-8 py-4 rounded-full text-lg font-semibold hover:shadow-2xl transform hover:scale-105 transition-all duration-300">
              Solicitar Orçamento
            </WhatsAppLink>
            <button
              onClick={() => scrollToSection('produtos')}
              className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full text-lg font-semibold border-2 border-white/30 hover:border-white hover:bg-white/20 transform hover:scale-105 transition-all duration-300"
            >
              Ver Produtos
            </button>
          </div>

          {/* Stats */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 shadow-lg border border-white/10">
              <div className="text-4xl font-bold bg-gradient-to-r from-[#4da8e8] to-white bg-clip-text text-transparent">
                500+
              </div>
              <div className="text-gray-300 mt-2">Clientes Satisfeitos</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 shadow-lg border border-white/10">
              <div className="text-4xl font-bold bg-gradient-to-r from-[#e84860] to-[#f3eb03] bg-clip-text text-transparent">
                10.000+
              </div>
              <div className="text-gray-300 mt-2">Peças Produzidas</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 shadow-lg border border-white/10">
              <div className="text-4xl font-bold bg-gradient-to-r from-[#f3eb03] to-[#4da8e8] bg-clip-text text-transparent">
                99%
              </div>
              <div className="text-gray-300 mt-2">Satisfação</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <svg
          className="w-6 h-6 text-white/60"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
    </section>
  )
}

export default Hero

